<template>
    <div id="room-gallery-modal" class="room-gallery-modal">
      <div class="gallery-header">
        <h2 class="gallery-title">Les chambres</h2>
        <div class="close-btn" @click="$emit('close')">✕</div>
      </div>
  
      <div class="room-thumbnails" :class="{ 'scrollable': isDesktop }">
        <div 
          v-for="(room, index) in sortedRooms"
          :key="index"
          v-if="room.photo_banner"
          :class="['room-tab', { active: selectedRoomIndex === index }]"
          @click="selectedRoomIndex = index"
        >
          <img :src="room.photo_banner" class="room-thumbnail" />
          <div class="room-labels">
            <p class="room-name text-uppercase">{{ room.name }}</p>
            <p class="room-bed">{{ room.bed_type }}</p>
            <div class="capacity mt-1">
              <p class="raleway-reg-p20 mb-0 mr-1">{{ room.capacity }}</p>
              <img src="../../images/1.svg" style="height: 25px; width: 25px;" v-set-alt />
            </div>
          </div>
        </div>
      </div>
  
      <div class="selected-room">
        <div class="room-image-grid">
          <div class="main-image" v-if="roomImages[0]">
            <img :src="roomImages[0]" />
          </div>
          <div class="side-images">
            <img v-for="(img, i) in roomImages.slice(1, 3)" :key="i" :src="img" />
          </div>
        </div>
        <div class="room-image-sub">
          <img v-for="(img, i) in roomImages.slice(3)" :key="i" :src="img" />
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'RoomGalleryModal',
    props: {
      item: Object
    },
    data() {
      return {
        selectedRoomIndex: 0,
        defaultRoomImage: '/images/default-room.jpg'
      }
    },
    methods: {
      naturalSort(a, b) {
        /**
        * Natural/alphanumeric sort for room names
        * Handles names like 'Chambre 2', 'Chambre 1', 'Chambre 10'
        * and sorts them as 1, 2, 3... instead of 1, 10, 2...
        */
        const nameA = a.name.toLowerCase();
        const nameB = b.name.toLowerCase();
        
        // Extract numbers from the room names
        const regex = /(\d+)/g;
        const numbersA = nameA.match(regex) || [];
        const numbersB = nameB.match(regex) || [];
        
        // If both have numbers, compare the first number
        if (numbersA.length > 0 && numbersB.length > 0) {
          const numA = parseInt(numbersA[0], 10);
          const numB = parseInt(numbersB[0], 10);
          if (numA !== numB) {
            return numA - numB;
          }
        }
        
        // Fall back to standard string comparison
        return nameA.localeCompare(nameB);
      }
    },
    computed: {
      roomImages() {
        return this.item.rooms?.[this.selectedRoomIndex]?.photos_keys || []
      },
      isDesktop() {
        return window.innerWidth > 768
      },
       sortedRooms() {
         return this.item.rooms.sort(this.naturalSort);
       }
    }
  }
  </script>
  
  <style scoped>
  .room-gallery-modal {
    background: #000000f0;
    color: white;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow-y: auto;
    z-index: 1000;
    padding: 20px;
  }
  .gallery-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 10px;
  }
  .close-btn {
    font-size: 24px;
    cursor: pointer;
  }
  .gallery-title {
    font-size: 22px;
    font-weight: 600;
    font-family: "Raleway";
  }
  .room-thumbnails {
    display: flex;
    overflow-x: auto;
    gap: 15px;
    margin-bottom: 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid #888;
  }
  .room-tab {
    flex-shrink: 0;
    text-align: center;
    cursor: pointer;
    border-radius: 8px;
    padding: 8px;
    background: #222;
    min-width: 260px;
    max-width: 300px;
  }
  .room-tab.active {
    background: #CFE5DC;
  }
  .room-thumbnail {
    width: 100px;
    height: 60px;
    object-fit: cover;
    border-radius: 4px;
  }
  .room-labels {
    margin-top: 5px;
  }
  .room-name {
    font-size: 13px;
    margin: 0;
  }
  .room-bed {
    font-size: 11px;
    opacity: 0.7;
    margin: 0;
  }
  .selected-room {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .room-image-grid {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
  }
  .main-image {
    flex: 2;
    min-width: 60%;
  }
  .main-image img {
    width: 100%;
    max-height: 600px;
    border-radius: 8px;
    object-fit: cover;
  }
  .side-images {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 10px;
    min-width: 35%;
  }
  .side-images img {
    width: 100%;
    border-radius: 8px;
    max-height: 290px;
    object-fit: cover;
  }
  .room-image-sub {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
    justify-content: center;
  }
  .room-image-sub img {
    width: calc(50% - 5px);
    max-width: 500px;
    max-height: 350px;
    border-radius: 8px;
    object-fit: cover;
  }
  @media (max-width: 768px) {
    .room-thumbnail {
      width: 80px;
      height: 50px;
    }
    .main-image img {
      max-height: 300px;
    }
    .side-images {
      flex-direction: row;
      gap: 10px;
    }
    .side-images img {
      max-height: 150px;
    }
    .room-image-sub img {
      width: 100%;
      max-height: 250px;
    }
  }
  .capacity {
  display: flex;
  align-items: center;
  margin-left: 1rem;
  margin-left: auto;
}
  </style>  